if (!customElements.get('case-study-gallery-modal')) {
  customElements.define(
    'case-study-gallery-modal',
    class CaseStudyGalleryModal extends ModalDialog {
      constructor() {
        super();
        this.activeIndex = 0;
        this.slides = Array.from(this.querySelectorAll('[data-media-id]'));
        this.counterCurrent = this.querySelector('.case-study-gallery-modal__counter-current');
        this.counterTotal = this.querySelector('.case-study-gallery-modal__counter-total');
        if (this.counterTotal) this.counterTotal.textContent = this.slides.length;

        this.querySelector('[data-action="prev"]')?.addEventListener('click', () => {
          this.showSlide(this.activeIndex - 1);
        });
        this.querySelector('[data-action="next"]')?.addEventListener('click', () => {
          this.showSlide(this.activeIndex + 1);
        });

        this.addEventListener('keyup', (event) => {
          if (event.code === 'ArrowRight') this.showSlide(this.activeIndex + 1);
          if (event.code === 'ArrowLeft') this.showSlide(this.activeIndex - 1);
        });
      }

      show(opener) {
        super.show(opener);
        const index = this.slides.findIndex((slide) => slide.dataset.mediaId === opener.dataset.mediaId);
        this.showSlide(index === -1 ? 0 : index);
      }

      showSlide(index) {
        if (this.slides.length === 0) return;
        this.activeIndex = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => slide.classList.toggle('active', i === this.activeIndex));
        if (this.counterCurrent) this.counterCurrent.textContent = this.activeIndex + 1;
      }
    }
  );
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-case-study-gallery-modal]');
  if (!trigger) return;
  const modal = document.getElementById(trigger.dataset.caseStudyGalleryModal);
  if (modal) modal.show(trigger);
});
